import { useEffect } from "react";
import Reveal from "../components/Reveal";
import StrongCTA from "../components/home/StrongCTA";

export default function MisionVisionPage() {
  useEffect(() => {
    document.title = "Misión y Visión | Ospino & Piñeres Abogados";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="pt-36 pb-16 md:pt-44 md:pb-20 bg-white border-b border-slate-100">
        <div className="container-x">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="gold-rule" />
              <span className="overline">Propósito</span>
            </div>
            <h1 className="font-serif text-navy-900 text-4xl md:text-5xl lg:text-6xl leading-[1.05] max-w-4xl">
              Misión y <em className="italic" style={{ color: "#C5A059" }}>Visión</em>
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-10">
          <Reveal>
            <div className="border-t-2 pt-8" style={{ borderColor: "#C5A059" }}>
              <span
                className="text-xs font-bold uppercase tracking-[0.22em]"
                style={{ color: "#C5A059" }}
              >
                Misión
              </span>
              <p className="mt-6 text-slate-700 leading-relaxed text-[17px]">
                Brindar soluciones jurídicas y contables integrales a empresas y organizaciones nacionales e internacionales, con sede en la Costa Norte y presencia en todo el territorio colombiano. Nuestro propósito es garantizar seguridad normativa, eficiencia fiscal y respaldo técnico que contribuyan a la solidez económica y financiera de nuestros clientes, fortaleciendo el desarrollo sostenible de sus actividades empresariales y el cumplimiento de su objeto social.
              </p>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <div className="border-t-2 pt-8" style={{ borderColor: "#0A192F" }}>
              <span
                className="text-xs font-bold uppercase tracking-[0.22em] text-navy-900"
              >
                Visión
              </span>
              <p className="mt-6 text-slate-700 leading-relaxed text-[17px]">
                Posicionarse como una firma líder en consultoría jurídica y contable integral, con reconocimiento institucional y gremial, orientada a brindar soluciones especializadas y de alto impacto en los distintos niveles de la legislación nacional e internacional. Nuestro propósito es consolidarnos como aliado estratégico de empresas y entidades, aportando valor normativo, eficiencia operativa y respaldo técnico en sus procesos de decisión, cumplimiento y defensa.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <StrongCTA />
    </>
  );
}